import { doc, updateDoc } from "firebase/firestore"
import { auth, db } from "./firebase"

export const RCWidth = '81%'

export const countries = () => {
    return (
        <>
              <option value="">Select Location</option>
              <option value="AF">Afghanistan</option>
              <option value="AL">Albania</option>
              <option value="DZ">Algeria</option>
              <option value="AS">American Samoa</option>
              <option value="AD">Andorra</option>
              <option value="AO">Angola</option>
              <option value="AI">Anguilla</option>
              <option value="AQ">Antarctica</option>
              <option value="AG">Antigua and Barbuda</option>
              <option value="AR">Argentina</option>
              <option value="AM">Armenia</option>
              <option value="AW">Aruba</option>
              <option value="AU">Australia</option>
              <option value="AT">Austria</option>
              <option value="AZ">Azerbaijan</option>
              <option value="BS">Bahamas</option>
              <option value="BH">Bahrain</option>
              <option value="BD">Bangladesh</option>
              <option value="BB">Barbados</option>
              <option value="BY">Belarus</option>
              <option value="BE">Belgium</option>
              <option value="BZ">Belize</option>
              <option value="BJ">Benin</option>
              <option value="BM">Bermuda</option>
              <option value="BT">Bhutan</option>
              <option value="BO">Bolivia</option>
              <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
              <option value="BA">Bosnia and Herzegovina</option>
              <option value="BW">Botswana</option>
              <option value="BV">Bouvet Island</option>
              <option value="BR">Brazil</option>
              <option value="IO">British Indian Ocean Territory</option>
              <option value="BN">Brunei Darussalam</option>
              <option value="BG">Bulgaria</option>
              <option value="BF">Burkina Faso</option>
              <option value="BI">Burundi</option>
              <option value="KH">Cambodia</option>
              <option value="CM">Cameroon</option>
              <option value="CA">Canada</option>
              <option value="CV">Cape Verde</option>
              <option value="KY">Cayman Islands</option>
              <option value="CF">Central African Republic</option>
              <option value="TD">Chad</option>
              <option value="CL">Chile</option>
              <option value="CN">China</option>
              <option value="CX">Christmas Island</option>
              <option value="CC">Cocos (Keeling) Islands</option>
              <option value="CO">Colombia</option>
              <option value="KM">Comoros</option>
              <option value="CG">Congo</option>
              <option value="CD">Congo, the Democratic Republic of the</option>
              <option value="CK">Cook Islands</option>
              <option value="CR">Costa Rica</option>
              <option value="CI">Cote D'Ivoire</option>
              <option value="HR">Croatia</option>
              <option value="CU">Cuba</option>
              <option value="CW">Curaçao</option>
              <option value="CY">Cyprus</option>
              <option value="CZ">Czech Republic</option>
              <option value="DK">Denmark</option>
              <option value="DJ">Djibouti</option>
              <option value="DM">Dominica</option>
              <option value="DO">Dominican Republic</option>
              <option value="EC">Ecuador</option>
              <option value="EG">Egypt</option>
              <option value="SV">El Salvador</option>
              <option value="GQ">Equatorial Guinea</option>
              <option value="ER">Eritrea</option>
              <option value="EE">Estonia</option>
              <option value="SZ">Eswatini</option>
              <option value="ET">Ethiopia</option>
              <option value="FK">Falkland Islands (Malvinas)</option>
              <option value="FO">Faroe Islands</option>
              <option value="FJ">Fiji</option>
              <option value="FI">Finland</option>
              <option value="FR">France</option>
              <option value="GF">French Guiana</option>
              <option value="PF">French Polynesia</option>
              <option value="TF">French Southern Territories</option>
              <option value="GA">Gabon</option>
              <option value="GM">Gambia</option>
              <option value="GE">Georgia</option>
              <option value="DE">Germany</option>
              <option value="GH">Ghana</option>
              <option value="GI">Gibraltar</option>
              <option value="GR">Greece</option>
              <option value="GL">Greenland</option>
              <option value="GD">Grenada</option>
              <option value="GP">Guadeloupe</option>
              <option value="GU">Guam</option>
              <option value="GT">Guatemala</option>
              <option value="GG">Guernsey</option>
              <option value="GN">Guinea</option>
              <option value="GW">Guinea-Bissau</option>
              <option value="GY">Guyana</option>
              <option value="HT">Haiti</option>
              <option value="HM">Heard Island and Mcdonald Islands</option>
              <option value="VA">Holy See (Vatican City State)</option>
              <option value="HN">Honduras</option>
              <option value="HK">Hong Kong</option>
              <option value="HU">Hungary</option>
              <option value="IS">Iceland</option>
              <option value="IN">India</option>
              <option value="ID">Indonesia</option>
              <option value="IR">Iran, Islamic Republic of</option>
              <option value="IQ">Iraq</option>
              <option value="IE">Ireland</option>
              <option value="IM">Isle of Man</option>
              <option value="IL">Israel</option>
              <option value="IT">Italy</option>
              <option value="JM">Jamaica</option>
              <option value="JP">Japan</option>
              <option value="JE">Jersey</option>
              <option value="JO">Jordan</option>
              <option value="KZ">Kazakhstan</option>
              <option value="KE">Kenya</option>
              <option value="KI">Kiribati</option>
              <option value="XK">Kosovo</option>
              <option value="KW">Kuwait</option>
              <option value="KG">Kyrgyzstan</option>
              <option value="LA">Lao People's Democratic Republic</option>
              <option value="LV">Latvia</option>
              <option value="LB">Lebanon</option>
              <option value="LS">Lesotho</option>
              <option value="LR">Liberia</option>
              <option value="LY">Libya</option>
              <option value="LI">Liechtenstein</option>
              <option value="LT">Lithuania</option>
              <option value="LU">Luxembourg</option>
              <option value="MO">Macao</option>
              <option value="MG">Madagascar</option>
              <option value="MW">Malawi</option>
              <option value="MY">Malaysia</option>
              <option value="MV">Maldives</option>
              <option value="ML">Mali</option>
              <option value="MT">Malta</option>
              <option value="MH">Marshall Islands</option>
              <option value="MQ">Martinique</option>
              <option value="MR">Mauritania</option>
              <option value="MU">Mauritius</option>
              <option value="YT">Mayotte</option>
              <option value="MX">Mexico</option>
              <option value="FM">Micronesia, Federated States of</option>
              <option value="MD">Moldova, Republic of</option>
              <option value="MC">Monaco</option>
              <option value="MN">Mongolia</option>
              <option value="ME">Montenegro</option>
              <option value="MS">Montserrat</option>
              <option value="MA">Morocco</option>
              <option value="MZ">Mozambique</option>
              <option value="MM">Myanmar</option>
              <option value="NA">Namibia</option>
              <option value="NR">Nauru</option>
              <option value="NP">Nepal</option>
              <option value="NL">Netherlands</option>
              <option value="NC">New Caledonia</option>
              <option value="NZ">New Zealand</option>
              <option value="NI">Nicaragua</option>
              <option value="NE">Niger</option>
              <option value="NG">Nigeria</option>
              <option value="NU">Niue</option>
              <option value="NF">Norfolk Island</option>
              <option value="KP">North Korea</option>
              <option value="MK">North Macedonia, Republic of</option>
              <option value="MP">Northern Mariana Islands</option>
              <option value="NO">Norway</option>
              <option value="OM">Oman</option>
              <option value="PK">Pakistan</option>
              <option value="PW">Palau</option>
              <option value="PS">Palestinian Territory, Occupied</option>
              <option value="PA">Panama</option>
              <option value="PG">Papua New Guinea</option>
              <option value="PY">Paraguay</option>
              <option value="PE">Peru</option>
              <option value="PH">Philippines</option>
              <option value="PN">Pitcairn</option>
              <option value="PL">Poland</option>
              <option value="PT">Portugal</option>
              <option value="PR">Puerto Rico</option>
              <option value="QA">Qatar</option>
              <option value="RE">Reunion</option>
              <option value="RO">Romania</option>
              <option value="RU">Russian Federation</option>
              <option value="RW">Rwanda</option>
              <option value="BL">Saint Barthélemy</option>
              <option value="SH">Saint Helena</option>
              <option value="KN">Saint Kitts and Nevis</option>
              <option value="LC">Saint Lucia</option>
              <option value="MF">Saint Martin (French part)</option>
              <option value="PM">Saint Pierre and Miquelon</option>
              <option value="VC">Saint Vincent and the Grenadines</option>
              <option value="WS">Samoa</option>
              <option value="SM">San Marino</option>
              <option value="ST">Sao Tome and Principe</option>
              <option value="SA">Saudi Arabia</option>
              <option value="SN">Senegal</option>
              <option value="RS">Serbia</option>
              <option value="SC">Seychelles</option>
              <option value="SL">Sierra Leone</option>
              <option value="SG">Singapore</option>
              <option value="SX">Sint Maarten (Dutch part)</option>
              <option value="SK">Slovakia</option>
              <option value="SI">Slovenia</option>
              <option value="SB">Solomon Islands</option>
              <option value="SO">Somalia</option>
              <option value="ZA">South Africa</option>
              <option value="GS">South Georgia and the South Sandwich Islands</option>
              <option value="KR">South Korea</option>
              <option value="SS">South Sudan</option>
              <option value="ES">Spain</option>
              <option value="LK">Sri Lanka</option>
              <option value="SD">Sudan</option>
              <option value="SR">Suriname</option>
              <option value="SJ">Svalbard and Jan Mayen</option>
              <option value="SE">Sweden</option>
              <option value="CH">Switzerland</option>
              <option value="SY">Syrian Arab Republic</option>
              <option value="TW">Taiwan</option>
              <option value="TJ">Tajikistan</option>
              <option value="TZ">Tanzania, United Republic of</option>
              <option value="TH">Thailand</option>
              <option value="TL">Timor-Leste</option>
              <option value="TG">Togo</option>
              <option value="TK">Tokelau</option>
              <option value="TO">Tonga</option>
              <option value="TT">Trinidad and Tobago</option>
              <option value="TN">Tunisia</option>
              <option value="TR">Turkey</option>
              <option value="TM">Turkmenistan</option>
              <option value="TC">Turks and Caicos Islands</option>
              <option value="TV">Tuvalu</option>
              <option value="UG">Uganda</option>
              <option value="UA">Ukraine</option>
              <option value="GB">United Kingdom</option>
              <option value="UM">United States Minor Outlying Islands</option>
              <option value="US">United States of America</option>
              <option value="UY">Uruguay</option>
              <option value="UZ">Uzbekistan</option>
              <option value="VU">Vanuatu</option>
              <option value="VE">Venezuela</option>
              <option value="VN">Vietnam</option>
              <option value="VG">Virgin Islands, British</option>
              <option value="VI">Virgin Islands, U.S.</option>
              <option value="WF">Wallis and Futuna</option>
              <option value="EH">Western Sahara</option>
              <option value="YE">Yemen</option>
              <option value="ZM">Zambia</option>
              <option value="ZW">Zimbabwe</option>
              <option value="AX">Åland Islands</option>
        </>
    )
}


export const countries2 = () => {
  return (
    <>
      <option value="">Select Location</option>
      <option value="au">Australia</option>
      <option value="br">Brazil</option>
      <option value="ca">Canada</option>
      <option value="fr">France</option>
      <option value="de">Germany</option>
      <option value="in">India</option>
      <option value="ie">Ireland</option>
      <option value="it">Italy</option>
      <option value="mx">Mexico</option>
      <option value="nl">Netherlands</option>
      <option value="sg">Singapore</option>
      <option value="es">Spain</option>
      <option value="uk">United Kingdom</option>
      <option value="us">United States of America</option>
    </>
  )
}


export const countries3 = () => {
  return (
    <>
    <option value="">Select Region</option>
    <option value="ap-northeast-1">Tokyo, Japan</option>
    <option value="eu-central-1">Frankfurt, Germany</option>
    <option value="eu-west-2">London, United Kingdom</option>
    <option value="us-east-1" selected>Washington D.C, United States</option>
    <option value="us-west-1">San Francisco, United States</option>
    <option value="ap-southeast-2">Sydney, Australia</option>
    <option value="sa-east-1">São Paulo, Brazil</option>
    </>
  )
}



export const generateCircleDot = (size, authority) => {
    const numericAuthority = parseInt(authority);
    let color;
    if (isNaN(numericAuthority)) {
      // Handle cases where authority is not a valid number
      color = 'gray';
    } else if (numericAuthority < 20) {
      color = 'red'; // Low authority
    } else if (numericAuthority >= 20 && numericAuthority < 55) {
      color = 'orange'; // Moderate authority
    } else if (numericAuthority >= 55 && numericAuthority < 60) {
      color = 'yellowgreen'; // Moderate to high authority
    } else {
      color = 'green'; // High authority
    }
    return <div className="circle-dot" style={{ width: size, height: size, backgroundColor: color, borderRadius: '50%' }} />;
  };


export const generateCircleDotCR = (size, authority) => {
    const numericAuthority = parseInt(authority);
    let color;
    if (isNaN(numericAuthority)) {
      // Handle cases where authority is not a valid number
      color = 'gray';
    } else if (numericAuthority < 20) {
      color = '#00c000'; // Low authority
    } else if (numericAuthority >= 20 && numericAuthority < 55) {
      color = '#eaa11b'; // Moderate authority
    } else if (numericAuthority >= 55 && numericAuthority < 60) {
      color = '#d9cb00'; // Moderate to high authority
    } else {
      color = '#e7072d'; // High authority
    }
    return <div className="circle-dot" style={{ width: size, height: size, backgroundColor: color, borderRadius: '50%' }} />;
  };
  


  export const generateDiffDot = (size, difficulty) => {
    const numericDifficulty = parseInt(difficulty);
    let color;
  
    if (isNaN(numericDifficulty)) {
      // Handle cases where difficulty is not a valid number
      color = 'gray';
    } else if (numericDifficulty <= 39) {
      color = 'green'; // Low difficulty
    } else if (numericDifficulty > 39 && numericDifficulty <= 50) {
      color = 'yellow'; // Moderate difficulty
    } else if (numericDifficulty > 50 && numericDifficulty <= 70) {
      color = 'orange'; // Moderate to high difficulty
    } else {
      color = 'red'; // High difficulty
    }
  
    return <div className="circle-dot" style={{ width: size, height: size, backgroundColor: color, borderRadius: '50%' }} />;
  };


  
  export const ProgressCircle = ({ percentage }) => {
    let color = '#00ff00'; // default green color
    if (percentage >= 0 && percentage < 25) {
      color = 'red';
    } else if (percentage >= 25 && percentage < 50) {
      color = 'orange';
    } else if (percentage >= 50 && percentage < 75) {
      color = 'yellow';
    }
  
    const radius = 30;
    const circumference = 2 * Math.PI * radius;
  
    const dashArray = circumference;
    const dashOffset = circumference - (percentage / 100) * circumference;
  
    return (
      <svg width="200" height="200" viewBox="0 0 100 100">
        <circle
          cx="50"
          cy="50"
          r={radius}
          fill="transparent"
          stroke="#ccc"
          strokeWidth="8"
        />
        <circle
          cx="50"
          cy="50"
          r={radius}
          fill="transparent"
          stroke={color}
          strokeWidth="8"
          strokeDasharray={dashArray}
          strokeDashoffset={dashOffset}
          strokeLinecap="round"
        />
        <text x="50%" y="50%" textAnchor="middle" dy=".3em">
          {percentage}%
        </text>
      </svg>
    );
  };


  export const krPhrases = [
    "Unearthing the latest keyword gems",
    "Delving into the realm of valuable search terms",
    "Scouring the web for top-ranking keywords",
    "Diving deep for sought-after keyword treasures",
    "Navigating the seas of search terms",
    "Hunting for the most lucrative keywords",
    "Exploring the world of high-traffic search terms",
    "Harvesting valuable keyword insights",
    "Sifting through keyword data for golden nuggets",
    "Mining the web for top-performing keywords",
  ];
  


  export const generateDomainDot = (size, authority) => {
    const numericAuthority = parseInt(authority);
    let color;
    if (isNaN(numericAuthority)) {
      // Handle cases where authority is not a valid number
      color = 'gray';
    } else if (numericAuthority >= 45 && numericAuthority <= 100) {
      color = 'rgb(23, 211, 23)'; // High authority
    } else if (numericAuthority >= 30 && numericAuthority < 45) {
      color = 'greenyellow'; // Greenish yellow
    } else if (numericAuthority >= 15 && numericAuthority < 30) {
      color = 'orange'; // Orange
    } else {
      color = 'red'; // Low authority
    }
    return <div className="circle-dot" style={{ width: size, height: size, backgroundColor: color, borderRadius: '50%' }} />;
};



export const deepClone = (obj) => {
  if(obj === null || typeof obj !== 'object') {
    return obj
  }


  let clone = Array.isArray(obj) ? [] : {}

  for(let key in obj) {
    if(Object.prototype.hasOwnProperty.call(obj, key)) {
      clone[key] = deepClone(obj[key])
    }
  }

  return clone
}


export const deltaT = (lastUTCDate, n) => {
  try {
    const lastUpdated = new Date(lastUTCDate)

    const currentTime = new Date()

    const timeDifference = currentTime.getTime() - lastUpdated.getTime()

    const msInADay = 24 * 60 * 60 * 1000

    const delta_t = timeDifference / msInADay

    return delta_t < n
  } catch (error) {
    return false
  }
}


export function checkUpdateTime(date, selectedInterval) {
  // Convert the given date string to a Date object
  const givenDate = new Date(date);
  
  // Get the current date and time
  const currentDate = new Date();
  
  // Calculate the difference in milliseconds
  const diffInMillis = currentDate - givenDate;
  
  // Convert the interval string to milliseconds
  let intervalInMillis;
  switch (selectedInterval) {
      case '24h':
          intervalInMillis = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
          break;
      case '3d':
          intervalInMillis = 3 * 24 * 60 * 60 * 1000; // 3 days in milliseconds
          break;
      case '1w':
          intervalInMillis = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
          break;
      default:
          throw new Error('Invalid interval. Use "24h", "3d", or "1w".');
  }
  
  // Check if the difference exceeds the interval
  return diffInMillis >= intervalInMillis;
}


export const ensureFullURL = (url) => {
  if (!/^https?:\/\//i.test(url)) {
      return `https://${url}`;
  }
  return url;
};


export const isValidURL = (url) => {
  try {
      new URL(url);
      return true;
  } catch (e) {
      return false;
  }
};


export const isValidURL_adv = (url) => {
  const urlPattern = new RegExp(
    '^' + // Start of string
    '(https?:\\/\\/)?' + // Optional protocol (http:// or https://)
    '((([a-zA-Z0-9-_]+)\\.)+[a-zA-Z]{2,})' + // Domain name
    '(\\/[a-zA-Z0-9#-_.?=&]*)?' + // Optional path
    '$', // End of string
    'i' // Case-insensitive flag
  );
  
  return urlPattern.test(url);
};



export function getRootDomain(url) {
  if (typeof url !== 'string') {
    return 'the root domain';
  }

  // Ensure the URL starts with https://
  const formattedUrl = url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
  
  // Create a URL object
  const parsedUrl = new URL(formattedUrl);

  return parsedUrl;
}



export function getRootDomain_adv(url) {
  if (typeof url !== 'string') {
    return 'the root domain';
  }

  const formattedUrl = url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
  const parsedUrl = new URL(formattedUrl);

  return parsedUrl.hostname; // Return the root domain
}




export function getLanguageName(langCode) {
  const languageMap = {
      'en': 'English',
      'en-us': 'US English',
      'en-gb': 'UK English',
      'en-uk': 'UK English',
      'en-au': 'Australian English',
      'fr': 'French',
      'es': 'Spanish',
      'de': 'German',
      'it': 'Italian',
      'pt': 'Portuguese',
      'zh': 'Chinese',
      'ja': 'Japanese',
      'ru': 'Russian',
      'ar': 'Arabic',
      'ko': 'Korean',
      'hi': 'Hindi',
      'bn': 'Bengali',
      'pa': 'Punjabi',
      'jv': 'Javanese',
      'vi': 'Vietnamese',
      'tl': 'Tagalog',
      'th': 'Thai',
      'tr': 'Turkish',
      'uk': 'Ukrainian',
      'el': 'Greek',
      'he': 'Hebrew',
      'sw': 'Swahili',
      'fi': 'Finnish',
      'no': 'Norwegian',
      'da': 'Danish',
      'sv': 'Swedish',
      'hu': 'Hungarian',
      'cs': 'Czech',
      'ro': 'Romanian',
      'sk': 'Slovak',
      'bg': 'Bulgarian',
      'sl': 'Slovenian',
      'is': 'Icelandic',
      'ms': 'Malay',
      'mt': 'Maltese',
      'la': 'Latin',
      'cy': 'Welsh',
      'xh': 'Xhosa',
      'zu': 'Zulu',
      // Add more languages as needed
  };

  const normalizedCode = langCode.toLowerCase();

  // Return the language name or a fallback if not found
  return languageMap[normalizedCode] || langCode;
}


// export const getColorForDifficulty = (difficulty) => {
//   // Convert difficulty to a number if it's a string
//   const difficultyValue = typeof difficulty === 'string' ? parseFloat(difficulty) : difficulty;

//   // Ensure difficulty is a valid number and clamp between 0 and 100
//   const clampedDifficulty = isNaN(difficultyValue) ? 0 : Math.min(Math.max(difficultyValue, 0), 100);

//   // Define colors for easy and hard difficulties
//   const easyColor = { r: 0, g: 255, b: 0 }; // Green for easy
//   const hardColor = { r: 255, g: 0, b: 0 }; // Red for hard

//   // Interpolate between easy and hard colors based on difficulty
//   const interpolateColor = (t, color1, color2) => ({
//       r: Math.round(color1.r + t * (color2.r - color1.r)),
//       g: Math.round(color1.g + t * (color2.g - color1.g)),
//       b: Math.round(color1.b + t * (color2.b - color1.b))
//   });

//   // Calculate interpolation factor
//   const t = clampedDifficulty / 100;

//   // Get interpolated color
//   const color = interpolateColor(t, easyColor, hardColor);

//   // Define transparency based on difficulty (more difficult is more transparent)
//   const alpha = 0.25; // Adjust transparency as needed (0.1 to 0.9 range)

//   // Return color in RGBA format
//   return `rgba(${color.r}, ${color.g}, ${color.b}, ${alpha})`;
// };


export const getColorForDifficulty = (difficulty) => {
  // Convert difficulty to a number if it's a string
  const difficultyValue = typeof difficulty === 'string' ? parseFloat(difficulty) : difficulty;

  // Ensure difficulty is a valid number and clamp between 0 and 100
  const clampedDifficulty = isNaN(difficultyValue) ? 0 : Math.min(Math.max(difficultyValue, 0), 100);

  // Define colors for each difficulty range
  if (clampedDifficulty >= 0 && clampedDifficulty <= 25) return '#c5ffc5'; // Light green
  if (clampedDifficulty >= 26 && clampedDifficulty <= 35) return '#4ad265'; // Green
  if (clampedDifficulty >= 36 && clampedDifficulty <= 45) return '#ffeb3b'; // Yellow
  if (clampedDifficulty >= 46 && clampedDifficulty <= 65) return '#f3b65b'; // Orange
  if (clampedDifficulty >= 66 && clampedDifficulty <= 75) return '#de8c48'; // Red orange
  return '#e5766e'; // Red (for difficulty between 76 and 100)
};


export function calculateNicheMarketPotentialScore(keywords) {
  // Calculate min and max for normalization
  const volumes = keywords.map(k => k.volume);
  const cpcs = keywords.map(k => k.cpc);
  const difficulties = keywords.map(k => k.difficulty);

  const minVolume = Math.min(...volumes);
  const maxVolume = Math.max(...volumes);
  const minCPC = Math.min(...cpcs);
  const maxCPC = Math.max(...cpcs);
  const minDifficulty = Math.min(...difficulties);
  const maxDifficulty = Math.max(...difficulties);

  // Function to normalize a value
  function normalize(value, min, max) {
      return (value - min) / (max - min);
  }

  // Weights
  const volumeWeight = 0.50;
  const cpcWeight = 0.30;
  const difficultyWeight = 0.20;

  // Calculate the Market Potential Score for each keyword
  const scores = keywords.map(keyword => {
      const normalizedVolume = normalize(keyword.volume, minVolume, maxVolume);
      const normalizedCPC = 1 - normalize(keyword.cpc, minCPC, maxCPC); // Invert CPC
      const normalizedDifficulty = 1 - normalize(keyword.difficulty, minDifficulty, maxDifficulty); // Invert Difficulty

      const weightedVolume = normalizedVolume * volumeWeight;
      const weightedCPC = normalizedCPC * cpcWeight;
      const weightedDifficulty = normalizedDifficulty * difficultyWeight;

      return weightedVolume + weightedCPC + weightedDifficulty;
  });

  // Calculate the average Market Potential Score for the niche
  const nicheMarketPotentialScore = scores.reduce((sum, score) => sum + score, 0) / scores.length;

  // Convert to percentage
  return nicheMarketPotentialScore * 100;
}


export const extractDomainName = (url) => {
  // Remove protocol (http, https)
  let domain = url.replace(/^https?:\/\//, '');
  
  // Remove 'www.' prefix
  domain = domain.replace(/^www\./, '');
  
  // Extract the domain name before any '/' or '?' (if present)
  domain = domain.split(/[\/?]/)[0];
  
  return domain;
};


export function getVisibilityColor(visibility) {
  const percentage = parseFloat(visibility);

  if (percentage < 30) {
      return 'red';
  } else if (percentage >= 30 && percentage < 70) {
      return 'orange';
  } else if (visibility === 'N/A') {
    return 'black'
  } else {
    return '#06bb06';
  }
}



export const getCountryName = (code) => {
  const countryMap = {
    AF: 'Afghanistan',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CV: 'Cape Verde',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo, the Democratic Republic of the',
    CK: 'Cook Islands',
    CR: 'Costa Rica',
    CI: 'Cote D\'Ivoire',
    HR: 'Croatia',
    CU: 'Cuba',
    CW: 'Curaçao',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    SZ: 'Eswatini',
    ET: 'Ethiopia',
    FK: 'Falkland Islands (Malvinas)',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island and Mcdonald Islands',
    VA: 'Holy See (Vatican City State)',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran, Islamic Republic of',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'Isle of Man',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    XK: 'Kosovo',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: 'Lao People\'s Democratic Republic',
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia, Federated States of',
    MD: 'Moldova, Republic of',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    KP: 'North Korea',
    MK: 'North Macedonia, Republic of',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestinian Territory, Occupied',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Reunion',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    BL: 'Saint Barthélemy',
    SH: 'Saint Helena',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin (French part)',
    PM: 'Saint Pierre and Miquelon',
    VC: 'Saint Vincent and the Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten (Dutch part)',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    GS: 'South Georgia and the South Sandwich Islands',
    KR: 'South Korea',
    SS: 'South Sudan',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SJ: 'Svalbard and Jan Mayen',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan',
    TJ: 'Tajikistan',
    TZ: 'Tanzania, United Republic of',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    GB: 'United Kingdom',
    UM: 'United States Minor Outlying Islands',
    US: 'United States of America',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnam',
    VG: 'Virgin Islands, British',
    VI: 'Virgin Islands, U.S.',
    WF: 'Wallis and Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
    AX: 'Åland Islands'
  };


  return countryMap[code] || '';
};



export const updateNexFDB = async (cnx) => {
  await updateDoc(doc(db, 'users', auth.currentUser.uid), {nex: cnx - 1})
}


export function generateRandomNumbers() {
  const randomNumber = Math.floor(Math.random() * (9999999999 - 1000000000 + 1)) + 1000000000;
  return randomNumber.toString();
}


// export const base = 'http://localhost:5000'
export const base = 'https://origin.improwth.com'


export const rKey = "6LcvyOspAAAAACqQThofKafDANznsj-O-ALbhY7b"